import setting2 from "../../assets/images/setting-2.png";
import CurrencyWrapper from "./currency-chosen";
import WalletWrapper from "./connect-wallet";

export default function PanelBottom({ content, updateContent, coinList,sellContent }) {
  return (
    <div className="mx-2 flex justify-center">
      <div className="bottom-panel text-white md:w-[608px] w-full">
        <div className="px-2 py-4 md:p-4">
          <div className="YourSell">You Buy</div>

          <div className="relative overflow-x-auto mb-5">
            <div className="flex justify-between mt-6">
              <div className="flex">
                <img
                  className="h-auto max-w-full"
                  alt=""
                  width={36}
                  height={36}
                  src={content.iconUrl}
                />
                {/* //jh */}
                <select
                  id="currency"
                  className="bg-gray-50 w-20 text-lg md:text-2xl font-semibold bg-transparent text-white-900 border-none"
                  value={content.coinName}
                  onChange={(e) => {
                    const selectedCoin = coinList.find(coin => coin.symbol === e.target.value);
                    updateContent("coinName", selectedCoin.symbol);
                    updateContent("displayName", selectedCoin.name);
                    updateContent("iconUrl", selectedCoin.iconUrl);
                  }}
                >
                  {coinList.map(coin => (
                    <option key={coin.id} value={coin.symbol}>
                      {coin.symbol}
                    </option>
                  ))}
                </select>
              </div>
              <div className="  flex justify-end">
                <input
                  type="number"
                  value={content.amount && !isNaN(content.amount)
                    ? (parseFloat(content.amount) % 1 === 0
                        ? parseInt(content.amount, 10)
                        : parseFloat(content.amount).toFixed(5))
                    : '0'}
                  onChange={(e) =>
                    updateContent("amount", (e.target.value))
                  }
                  className="bg-transparent w-36 mr-2 text-lg md:text-2xl text-white  font-semibold border-none"
                />
              </div>
            </div>
            <div className="flex justify-between mt-6">
              <div className="flex">
                <p className="text-[#8C8C8C]">{content.displayName}</p>
              </div>
              <div>
                <p>
                  ${(content.price)}
                  {/* <span className="text-[#FF0000] ml-1 font-extralight">
                    (-0.29%)
                  </span> */}
                </p>
              </div>
            </div>
          </div>
          <CurrencyWrapper content={content} sellContent={sellContent} />
          <WalletWrapper />
        </div>
      </div>
    </div>
  );
}
